export default __webpack_public_path__ + "static/iellison-b57b5df55738b9ba9b9c3d988779e56a.png";